'use client';

import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { fmtDate } from '@/shared/dates';
import POHLogo from 'assets/images/POH-logo.jpg';
import { getDirectionsUrl } from '@/shared/geo';
import { smartTruncate } from '@/shared/text';
import Modal from '../atoms/Modal';
export default function PromotionDetails(t0) {
  const $ = _c(53);
  const {
    promotion,
    isOpen,
    onClose,
    onExpiredClose
  } = t0;
  const [expanded, setExpanded] = useState(false);
  promotion?.offerDetails;
  const t1 = promotion?.offerDetails || "";
  let t2;
  if ($[0] !== t1) {
    t2 = smartTruncate(t1, 300);
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    short,
    isTruncated
  } = t2;
  if (!isOpen || !promotion) {
    return null;
  }
  const isExpired = promotion.endDate ? new Date(promotion.endDate) < new Date() : false;
  let t3;
  if ($[2] !== promotion.locations) {
    t3 = promotion.locations || [];
    $[2] = promotion.locations;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const locations = t3;
  const hasMultipleLocations = locations.length > 0;
  if (isExpired) {
    let t4;
    if ($[4] !== onClose || $[5] !== onExpiredClose) {
      t4 = () => onExpiredClose ? onExpiredClose() : onClose();
      $[4] = onClose;
      $[5] = onExpiredClose;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    let t5;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="text-center py-8 px-4"><h2 className="text-2xl font-semibold text-[#323232] mb-4">This promotion has expired.</h2></div>;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== isOpen || $[9] !== t4) {
      t6 = <Modal isOpen={isOpen} onClose={t4}>{t5}</Modal>;
      $[8] = isOpen;
      $[9] = t4;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  let t4;
  if ($[11] !== onClose) {
    t4 = () => onClose();
    $[11] = onClose;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="text-center"><Image src={POHLogo} alt="parade of herts logo" width={80} height={57} className="h-full w-full object-cover max-w-[5em] mx-auto" priority={true} /></div>;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== promotion.thumbnail || $[15] !== promotion.title) {
    t6 = promotion.thumbnail && <div className="mx-auto w-36 h-36 rounded-full mt-19"><Image src={promotion.thumbnail} alt={promotion.title || "promotion thumbnail"} width={144} height={144} className="h-full w-full object-cover" priority={true} /></div>;
    $[14] = promotion.thumbnail;
    $[15] = promotion.title;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== promotion.vendor) {
    t7 = <p className="pt-4">{promotion.vendor}</p>;
    $[17] = promotion.vendor;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== promotion.offerText) {
    t8 = <p className="text-xl text-[#323232] font-semibold leading-[1.2em] max-w-[10em] mx-auto my-1">{promotion.offerText}</p>;
    $[19] = promotion.offerText;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== expanded || $[22] !== isTruncated || $[23] !== promotion.offerDetails || $[24] !== short) {
    t9 = promotion.offerDetails && <div id="promotion-offer-details" className="text-[#323232] leading-[1.6] my-4 text-left"><span className="whitespace-pre-wrap inline">{expanded || !isTruncated ? promotion.offerDetails : `${short}…`}</span>{isTruncated && <button type="button" aria-expanded={expanded} aria-controls="promotion-offer-details" aria-label={expanded ? "Collapse to hide additional content" : "Expand to read more content"} onClick={() => setExpanded(_temp)} className="inline items-center cursor-pointer gap-1 text-base font-medium text-[#626262] hover:underline focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-sky-600">{expanded ? "less" : "more"}</button>}</div>;
    $[21] = expanded;
    $[22] = isTruncated;
    $[23] = promotion.offerDetails;
    $[24] = short;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== hasMultipleLocations || $[27] !== locations) {
    t10 = hasMultipleLocations && <div className="mt-4 pt-4 border-t border-gray-200"><p className="text-[#323232] font-semibold mb-2">Available at {locations.length} location{locations.length > 1 ? "s" : ""}:</p><div className="space-y-2 max-h-40 overflow-y-auto">{locations.map(_temp2)}</div></div>;
    $[26] = hasMultipleLocations;
    $[27] = locations;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== promotion.url) {
    t11 = promotion.url && <p className="pt-6 leading-[1.25]"><span className="block text-[15px]">Company Website:</span><Link href={promotion.url} target="_blank" rel="noopener noreferrer" className="!text-[#757575] !text-[15px] underline break-all">{promotion.url}</Link></p>;
    $[29] = promotion.url;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <span>Valid Through</span>;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== promotion.startDate) {
    t13 = fmtDate(promotion.startDate);
    $[32] = promotion.startDate;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== promotion.endDate) {
    t14 = fmtDate(promotion.endDate);
    $[34] = promotion.endDate;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  let t15;
  if ($[36] !== t13 || $[37] !== t14) {
    t15 = <p className="mt-12">{t12}<span className="text-[#323232] font-semibold block">{t13} - {t14}</span></p>;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== t10 || $[40] !== t11 || $[41] !== t15 || $[42] !== t7 || $[43] !== t8 || $[44] !== t9) {
    t16 = <div className="text-[#757575] text-[15px] text-center font-normal leading-[1.6]">{t7}{t8}{t9}{t10}{t11}{t15}</div>;
    $[39] = t10;
    $[40] = t11;
    $[41] = t15;
    $[42] = t7;
    $[43] = t8;
    $[44] = t9;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t16 || $[47] !== t6) {
    t17 = <div>{t5}{t6}{t16}</div>;
    $[46] = t16;
    $[47] = t6;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  if ($[49] !== isOpen || $[50] !== t17 || $[51] !== t4) {
    t18 = <Modal isOpen={isOpen} onClose={t4}>{t17}</Modal>;
    $[49] = isOpen;
    $[50] = t17;
    $[51] = t4;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  return t18;
}
function _temp2(location, index) {
  const directionsUrl = location.coordinates?.[0] && location.coordinates?.[1] ? getDirectionsUrl(location.coordinates[0], location.coordinates[1], location.address) : null;
  return <div key={location.id || index} className="flex items-start gap-1 text-sm mx-auto w-fit">{directionsUrl && <Link href={directionsUrl} target="_blank" rel="noopener noreferrer" className="flex items-start gap-1"><span className="w-4 flex-shrink-0 mt-1"><svg width="11" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.032 11.3423C6.33622 10.1748 7.33428 9.05489 8.02617 7.98267C8.71806 6.91044 9.064 5.97133 9.064 5.16533C9.064 3.95 8.67789 2.95089 7.90567 2.168C7.13344 1.38511 6.17556 0.993667 5.032 0.993667C3.88844 0.993667 2.93056 1.38511 2.15833 2.168C1.38611 2.95089 1 3.95 1 5.16533C1 5.97133 1.34594 6.91044 2.03783 7.98267C2.72972 9.05489 3.72778 10.1748 5.032 11.3423ZM5.032 12.2935C4.90211 12.2935 4.77222 12.2711 4.64233 12.2263C4.51233 12.1814 4.39478 12.112 4.28967 12.018C3.69144 11.4667 3.13161 10.8989 2.61017 10.3147C2.08883 9.73056 1.63567 9.14661 1.25067 8.56283C0.865555 7.97906 0.560833 7.40044 0.3365 6.827C0.112167 6.25344 0 5.69955 0 5.16533C0 3.62689 0.497611 2.38139 1.49283 1.42883C2.48817 0.476277 3.66789 0 5.032 0C6.39611 0 7.57583 0.476277 8.57117 1.42883C9.56639 2.38139 10.064 3.62689 10.064 5.16533C10.064 5.69955 9.95183 6.25233 9.7275 6.82367C9.50317 7.39511 9.19956 7.97378 8.81667 8.55967C8.43367 9.14555 7.9815 9.7295 7.46017 10.3115C6.93883 10.8936 6.379 11.4603 5.78067 12.0115C5.67711 12.1055 5.55939 12.176 5.4275 12.223C5.29572 12.27 5.16389 12.2935 5.032 12.2935ZM5.03317 6.2435C5.36483 6.2435 5.64839 6.12539 5.88383 5.88917C6.11939 5.65294 6.23717 5.369 6.23717 5.03733C6.23717 4.70567 6.11906 4.42206 5.88283 4.1865C5.64661 3.95106 5.36261 3.83333 5.03083 3.83333C4.69917 3.83333 4.41561 3.95144 4.18017 4.18767C3.94461 4.42389 3.82683 4.70789 3.82683 5.03967C3.82683 5.37133 3.94494 5.65489 4.18117 5.89033C4.41739 6.12578 4.70139 6.2435 5.03317 6.2435Z" fill="#BABABA" /></svg></span><span className="text-[#626262] text-sm leading-[1.6]">{location?.address}</span></Link>}</div>;
}
function _temp(v) {
  return !v;
}